/*
 * Standard signup prompts and responses copy
 */

const standard = {
  color: '#30B58F', // default
  /*
   * Prompts
   */

  // Welcome
  welcomePrompt01: 'Hello!',
  welcomePrompt02: 'Welcome to Leaply!',
  welcomePrompt03: 'The official application platform for opportunities at some of your favourite organizations.',

  // Explain
  explainLeaply01: 'Leaply is an online application platform that makes it really simple to discover and apply for various kinds of opportunities.',
  explainLeaply02: 'The system matches your credentials against the application criteria of hundreds of listed opportunities and shows you instantly which ones you qualify for.',
  explainLeaply03: 'You can then easily apply to any (or all) of them using your Leaply profile and get notified each time someone at a particular organisation performs an action on your application.',
  explainLeaply04: "This way you are always kept up to date and you'll know exactly where your application is sitting in their selection process.",
  explainLeaply05: 'Does that answer your question?',

  // Account
  accountPrompt01: "Do you have a Leaply account yet? You'll need one in order to apply for opportunities listed on Leaply.",
  accountPrompt02: 'You can login below',
  accountPrompt03: 'Good! Let us quickly review your profile.',
  accountPrompt04: 'Where would you like to go next?',
  accountPrompt05: 'Okay, we have a few options for you.',
  accountPrompt06: 'How would you like to create your account?',
  accountPrompt07: 'We noticed that you have an existing Leaply account.',
  accountPrompt08: 'We have your email as %{candidate_email}',
  accountPrompt09: 'Is that correct?',
  accountPrompt10: 'Please provide a new email address.',
  accountPrompt11: 'Perfect!',

  // Terms and Conditions
  accountPrompt12: "Do you consent to Leaply using your Personal Information as described in Leaply's Privacy Policy?",

  // Name
  namePrompt01: 'Great!',
  namePrompt02: 'You are only two steps away from discovering the world of possibilities at Leaply!',
  namePrompt03: 'Please enter your first name and last name.',
  namePrompt04: 'Thanks %{candidate_first_names}, nice to meet you.',

  // Identity
  idPrompt01: 'Lastly, we require an identification number to ensure that your Leaply account is unique only to you.',
  idPrompt02: 'Please select your nationality and fill in the relevant identification (ID) field.',
  idPrompt03: 'Success! Your account has been registered, thanks %{candidate_first_names}.',

  // Final
  finalPrompt01: 'You are now able to explore and apply to all available opportunities listed on Leaply.',
  finalPrompt02: 'Please keep an eye out for emails from us containing further instructions.',
  finalPrompt03: 'Good luck with your applications and speak soon!',
  finalPrompt04: 'Do you confirm that the Personal Information you provide in this registration is complete, accurate and up to date?',

  /*
   * Responses
   */

  // Account
  accountResponse01: 'Could you tell me more about Leaply?',
  accountResponse02: "I'd like to apply for opportunities on Leaply",
  accountResponse03: 'I have an account, I just want to log in',
  accountResponse04: "Cool, I'm logged in now",
  accountResponse05: 'I would like to create an account',
  accountResponse06: "Cool, I'll use %{auth_providers}",
  accountResponse07: 'No, that is incorrect',
  accountResponse08: 'Perfect!',
  accountResponse09: "I consent to Leaply using my Personal Information as described in Leaply's Privacy Policy, available at https://about.leap.ly/assets/privacy_policy.pdf",

  // Name
  nameResponse01: 'My name is %{candidate_first_names} %{candidate_last_name}',

  // Identification
  idResponse01: 'My national identification number is %{candidate_identification}',

  // Final
  finalResponse01: 'I confirm all information I provide is and will be accurate and complete.',
}

const campaigns = {
  // Welcome
  welcomePrompt02: 'Welcome to the official application platform for opportunities at %{organization_name}.',
  welcomePrompt03: 'Powered by Leaply',

  // Explain
  explainLeaply01: 'Leaply is an online application platform that makes it really simple to discover and apply for available opportunities at %{organization_name}',
  explainLeaply02: 'The system matches your credentials against the requirements set by our screening managers and shows you instantly which of our opportunities you are eligible for.',
  explainLeaply03: 'You can then easily apply to any (or all) of them using your Leaply profile and get notified each time one of our screening managers performs an action on your application.',
  explainLeaply04: 'This way, you are always kept up to date and know exactly where your application is sitting in our screening process.',

  // Account
  accountPrompt01: "Do you have a Leaply account yet? You'll need one in order to apply for opportunities at %{organization_name}.",

  // Terms and Conditions
  accountPrompt12: "Do you consent to Leaply using your Personal Information as described in Leaply's Privacy Policy and sharing it with %{organization_name}?",

  // Name
  namePrompt02: 'You are only two steps away from discovering the world of possibilities at %{organization_name}!',

  // Final
  finalPrompt01: 'You are now able to explore and apply to a number of exclusive opportunities available at %{organization_name}.',
  finalPrompt02: 'Please keep an eye out for emails from Leaply containing further instructions.',
}

const mtn = {
  // Welcome
  welcomePrompt01: "Y'ello",
}

const studyTrust = {
  // Welcome
  welcomePrompt02: 'Welcome to the official bursary and scholarship application platform for opportunities administered by %{organization_name}.',

  // Explain
  explainLeaply01: 'Leaply is an online application platform that makes it really simple to discover and apply for available bursaries and scholarships as administered by %{organization_name}.',
  explainLeaply02: 'The system matches your credentials against the requirements set by our screening managers and shows you instantly which bursaries and/or scholarships you are eligible for.',
  explainLeaply03: 'You can then easily apply to any (or all) of them using your Leaply profile and get notified each time one of our screening managers performs an action on your application.',
  explainLeaply04: 'This way, you are always kept up to date and know exactly where your application is sitting in our screening process.',
}

export default {
  standard,
  campaigns,
  1: studyTrust,
  29: mtn,
  55: studyTrust,
  74: { color: '#0075C9' }, // Sanlam Group
}
